module.exports = __webpack_public_path__ + "assets/img/优鱼云控.43139d59.png";